import script from "./_v-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./_v-dialog.vue?vue&type=script&setup=true&lang=js"

import "./_v-dialog.vue?vue&type=style&index=0&id=e163d90c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e163d90c"]])

export default __exports__